import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppConfigurationService } from './services/app-configuration.service';
import { StyleManagerService } from './services/style-manager.service';
import { TokenService } from './services/token.service';

import { AuthGuard } from './guards/auth.guard';

import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';


@NgModule({

    imports: [

        CommonModule

    ],

    providers: [

        AppConfigurationService,
        StyleManagerService,
        TokenService,

        AuthGuard,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },

    ]

})
export class CoreModule { }
